import Cookies, { CookieSetOptions } from 'universal-cookie';

export enum ECookieKey {
  LANGUAGE = 'lang'
}

export default {
  get: (key: ECookieKey) => {
    const cookies = new Cookies();
    return cookies.get(key);
  },
  set: (key: ECookieKey, value: unknown, options?: CookieSetOptions) => {
    const cookies = new Cookies();
    cookies.set(key, value, options);
  }
};
